
import { Component, Vue } from 'vue-property-decorator'

/**
 * ページのメインタイトル(h1)の基底コンポーネント
 */
@Component
export default class TitlePage extends Vue {}
